export const PRIME = 
{
    Metadata:{Name:'PRIME',maxColumn:7,numRows:12},
    Sections:
    [
        {
            Headers:[
                "",
                "Definitely Disagree",
                "Somewhat Disagree",
                "Slightly Disagree",
                "Not Sure",
                "Slightly Agree",
                "Somewhat Agree",
                "Definitely Agree"
            ],
            Questions:[
                {
                    Prompt:"1. I think that I have felt that there are odd or unusual things going on that I can't explain.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"2. I think that I might be able to predict the future.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"3. I may have felt that there could possibly be something interrupting or controlling my thoughts,feelings, or actions.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"4. I have had the experience of doing something differently because of my superstitions.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"5. I think that I may get confused at times whether something I experience or perceive may be real or may be just part of my imagination or dreams.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"6. I have thought that it might be possible that other people can read my mind, or that I can read other's minds.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"7. I wonder if people may be planning to hurt me or even may be about to hurt me.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"8. I believe that I have special natural or supernatural gifts beyond my talents and natural strengths.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"9. I think I might feel like my mind is “playing tricks” on me.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"10. I have had the experience of hearing faint or clear sounds of people or a person mumbling or talking when there is no one near me.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"11. I think that I may hear my own thoughts being said out loud.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                },
                {
                    Prompt:"12. I have been concerned that I might be “going crazy”.",
                    Responses:[
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:0,Type:"radio"},
                        {Value:1,Type:"radio"},
                        {Value:1,Type:"radio"}
                    ]
                }
            ]
        }
    ]
}